import React from 'react';
import { Link } from 'react-router-dom';
import './SteelHome.css';

const SteelHome = () => {
  const productCategories = [
    { name: 'TMT Bars', icon: '🏗️', description: 'Fe-500 & Fe-550 grade TMT bars', link: '/steel-products#tmt' },
    { name: 'Steel Billets', icon: '🧱', description: 'Premium quality steel billets', link: '/steel-products#billets' },
    { name: 'Angle Bars', icon: '📐', description: 'Equal angle sections', link: '/steel-products#angle' },
    { name: 'Channel Sections', icon: '⎕', description: 'C-channels for structures', link: '/steel-products#channel' },
    { name: 'I-Beams', icon: '📊', description: 'ISMB beams for heavy structures', link: '/steel-products#beam' },
    { name: 'Flat Bars', icon: '📏', description: 'MS flat bars various sizes', link: '/steel-products#flat' }
  ];

  const applications = [
    { icon: '🏢', title: 'High-Rise Buildings', desc: 'TMT bars for columns, beams, slabs' },
    { icon: '🌉', title: 'Bridges & Flyovers', desc: 'Heavy structural steel sections' },
    { icon: '🏭', title: 'Industrial Sheds', desc: 'Channels, angles, beams' },
    { icon: '🏠', title: 'Residential Construction', desc: 'TMT bars for foundations' }
  ];

  return (
    <div className="steel-home">
      {/* Hero Section */}
      <section className="steel-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Masai Rolling Mills</h1>
            <p className="hero-tagline">Quality Steel for a Stronger Kenya</p>
            <p className="hero-description">
              Leading manufacturer of TMT bars, steel billets, and structural steel sections. 
              Recycling scrap steel for sustainable construction.
            </p>
            <div className="hero-buttons">
              <Link to="/steel-catalogue" className="btn btn-primary">View Catalogue</Link>
              <Link to="/contact" className="btn btn-outline">Get Quote</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="steel-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <h3>50,000+</h3>
              <p>Tons Annual Capacity</p>
            </div>
            <div className="stat-card">
              <h3>8-32mm</h3>
              <p>TMT Bar Diameters</p>
            </div>
            <div className="stat-card">
              <h3>Fe-500/550</h3>
              <p>Premium Grades</p>
            </div>
            <div className="stat-card">
              <h3>ISO 9001</h3>
              <p>Certified Quality</p>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="steel-categories">
        <div className="container">
          <h2>Our Product Range</h2>
          <p className="section-subtitle">Comprehensive steel solutions for every construction need</p>
          <div className="categories-grid">
            {productCategories.map((cat, index) => (
              <Link to={cat.link} key={index} className="category-card">
                <div className="category-icon">{cat.icon}</div>
                <h3>{cat.name}</h3>
                <p>{cat.description}</p>
                <span className="category-link">Learn More →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Applications */}
      <section className="steel-applications">
        <div className="container">
          <h2>Where Our Steel Is Used</h2>
          <div className="applications-grid">
            {applications.map((app, index) => (
              <div className="application-card" key={index}>
                <div className="app-icon">{app.icon}</div>
                <h3>{app.title}</h3>
                <p>{app.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Section */}
      <section className="steel-quality">
        <div className="container">
          <div className="quality-content">
            <h2>Premium Quality Steel</h2>
            <div className="quality-features">
              <div className="quality-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Thermo-Mechanical Treatment</h4>
                  <p>Advanced TMT process for superior strength and ductility</p>
                </div>
              </div>
              <div className="quality-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Earthquake Resistant</h4>
                  <p>High ductility for seismic zone applications</p>
                </div>
              </div>
              <div className="quality-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Corrosion Resistant</h4>
                  <p>Advanced rib pattern and composition</p>
                </div>
              </div>
              <div className="quality-feature">
                <span className="feature-icon">✓</span>
                <div>
                  <h4>Tested & Certified</h4>
                  <p>In-house lab testing for every batch</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="steel-cta">
        <div className="container">
          <h2>Ready to build with quality steel?</h2>
          <p>Contact our sales team for competitive pricing on bulk orders</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-light">Request Quote</Link>
            <a href="tel:0738200500" className="btn btn-outline-light">Call 0738 200500</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SteelHome;